import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import RadioGroupComponents from "../../commonComponents/RadioGroupComponents";
import ButtonComponents from "../../commonComponents/ButtonComponents";
import IndividualForm from "./forms/IndividualForm";
import BusinessForm from "./forms/BusinessForm";
import {
  addBusinessUserData,
  addBussnissRegUpdateFlow,
  addBussnissUpdateFlow,
  businessUserEmpty,
  getEmailStatus,
  getRegisterdInvestors,
  initialResetState,
  registerUser,
  setLoginInvestorId,
  setLoginUserdetails,
} from "../../../redux/slice/userSlice";
import dayjs from "dayjs";
import {
  capitalize,
  formatPhoneNumber,
  formatZipCode,
} from "../../../utils/formatUtils";
import moment from "moment/moment";
import { useMsal } from "@azure/msal-react";
import {
  getKycDetails,
  postKycDetails
} from "../../../redux/slice/ledgerSlice";
import { AppDispatch, RootState } from "../../../redux/types";
import { IndividualFormValues, BusinessFormValues, KycDetails } from "./type";
import { fetchStates } from "../../../redux/slice/countyStateSlice";
import {
  businessValidationSchema,
  individualValidationSchema,
} from "./formData";
import { toast, ToastContainer } from "react-toastify";
import { textColor } from "../../../utils/commonstyle";

const IdentityVerificationForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { instance } = useMsal();
  const msalInstance: any = instance;
  const { userData, loginInvestorId, loginUserDetails, bussinessUserdata, isBusinessRegUpdate } =
    useSelector((state: RootState) => state.user);
  const user = useSelector((state: RootState) => state.user);
  const { states } = useSelector((state: RootState) => state.stateCounty);
  const { businesscategory } = useSelector((state: any) => state.business);
  const [attemptCount, setAttemptCount] = useState(1); // Track the number of attempts
  const [selectedValue, setSelectedValue] = useState<string>("individual");
  const [checking, setChecking] = useState(false);
  const [kycError, setKycError] = useState<any>({});
  const [dialogOpenUpdate, setDialogOpenUpdate] = useState<boolean>(false);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [kycDetails, setKycdetails] = useState<KycDetails | null>(null);
  const [useremail, setEmail] = useState('')
  const [errors, setErrors] = useState({
  });
  const [openErrorModel, setOpenErrorModel] = useState(false)

  const activeAccount = msalInstance.getActiveAccount();

  const [timeOutInterval, setTimeOutInterval] = useState(40000);
  const inputRefs = useRef<{ [key: string]: HTMLInputElement | null }>({});

  const handleKycDetails = async () => {
    if (loginInvestorId) {
      try {
        const kycDetailsData = await dispatch(
          getKycDetails(loginInvestorId)
        ).unwrap();
        setKycdetails(kycDetailsData);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleCallFechtapi = async () => {
    const email = msalInstance.getActiveAccount()?.idTokenClaims?.email || useremail || sessionStorage.getItem('impersonateEmail');
    const response = await dispatch(getRegisterdInvestors(email)).unwrap();
    dispatch(setLoginUserdetails(response.response));
  };

  const individualFormik = useFormik<IndividualFormValues>({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      socialSecurityNumber: "",
      dateOfBirth: null,
      address: "",
      addressLine2: "",
      city: "",
      state: "",
      ZipCode: "",
      Country: "",
      documentId: "",
      documentType: "",
      documentState: "",
      documentCountry: "",
    },
    validationSchema: individualValidationSchema,
    validateOnChange: false,
    validateOnBlur: true, // Validate when field loses focus
    onSubmit: async (values) => {
      dispatch(businessUserEmpty());
      const normalizedData = normalizeUserData(values);
      setEmail(values.email)
      setKycError({});
      try {
        const data = {
          ...normalizedData,
          type: "individual",
        };
        if (!loginInvestorId) {
          setDialogOpen(true);
        } else {
          setDialogOpenUpdate(true);
        }
        const response = await dispatch(registerUser(data)).unwrap();
        if (
          response.apiData.statusCode === 201 ||
          response.apiData.statusCode === 200
        ) {
          if (!loginInvestorId) {
            await dispatch(
              postKycDetails(response.apiData.body.investorId)
            ).unwrap();
            dispatch(setLoginInvestorId(response.apiData.body.investorId));
          }
          setChecking(true);
        } else if (response.apiData.statusCode === 409) {
          if (response.apiData.body.includes("Email")) {
            const errorData = {
              ...individualFormik.errors,
              email: response.apiData.body,
            };
            individualFormik.setErrors(errorData);
            setDialogOpen(false);
            setChecking(false);
            setDialogOpenUpdate(false);
          }
        }
        if (
          response.apiData.statusCode === 400 ||
          response.apiData.statusCode === 401 ||
          response.apiData.statusCode === 403
        ) {
          setDialogOpen(false);
          setDialogOpenUpdate(false);
        } else if (response.apiData.statusCode === 500) {
          navigate("/kyc-kyb/identity-verification/failed");
          setDialogOpenUpdate(false);
          setDialogOpen(false);
        } else if (response.apiData.statusCode === 503) {
          setDialogOpenUpdate(false);
          setDialogOpen(false);
          if (typeof response.apiData.body === "string") {
            toast.error(response.apiData.body);
          }
        }
      } catch (error: any) {
        setOpenErrorModel(true)
        const jsonBodyString = error?.body.replace(/^Error:\s*/, '');
        const bodyObject = JSON.parse(jsonBodyString);
        if (error?.statusCode === 400) {
          let errorData: any = {};
          if (bodyObject?.message?.includes('email')) {
            errorData = {
              ...individualFormik.errors,
              email: bodyObject.message,
            };

          } else if (bodyObject?.message?.includes('SSN')) {
            errorData = {
              ...individualFormik.errors,
              socialSecurityNumber: bodyObject.message,
            };

          }
          setKycError(errorData);
          individualFormik.setErrors(errorData);
          setDialogOpenUpdate(false);
          setDialogOpen(false);
        }
      }
    },
  });

  // Business formik instance
  const businessFormik = useFormik<BusinessFormValues>({
    initialValues: {
      Email: "", // Default empty email
      Phone: "", // Default empty phone
      DeliveryLine: "", // Default empty delivery line 1
      DeliveryLine2: "", // Default empty delivery line 2 (optional)
      City: "", // Default empty city
      State: "", // Default empty state
      Country: "US", // Default country set to "US"
      ZipCode: "", // Default empty zip code
      IdNumber: "", // Default empty business ID number
      BusinessName: "", // Default empty business name
      BusinessTypeId: 0, // Default business type ID (can be updated later)
      BusinessCategoriesId: 0, // Default business category ID (can be updated later)
      OperatingAs: "", // Default empty operating as field
      BusinessWebsite: "", // Default empty business website
      UserType: "business", // Static user type as 'business'
      subCategory: 0,
      RegistrationDate: null,
      RegistrationState: ""
    },
    validationSchema: businessValidationSchema,
    onSubmit: async (values) => {
      businessFormik.setErrors({});
      const normalizedData = normalizeBusinessData(values);
      try {
        const data = {
          ...normalizedData,
          type: "business",
        };
        dispatch(addBusinessUserData(data));
        // const response = await dispatch(registerUser(data)).unwrap();

        // const IsInvestorAvailable = loginInvestorId && loginUserDetails?.Email === data.Email ? false : await dispatch(
        //   getEmailStatus(data.Email)
        // ).unwrap();
        // if (IsInvestorAvailable) {
        //   setDialogOpen(false);
        //   setChecking(false);
        //   setDialogOpenUpdate(false);
        //   const errorData = {
        //     ...businessFormik.errors,
        //     Email: "Email address is already in use",
        //   };
        //   businessFormik.setErrors(errorData);
        // } else {
        loginInvestorId && dispatch(addBussnissRegUpdateFlow(true))
        navigate("/kyc-kyb/identity-verification/business-info");
        // }
        // } else {
        //   navigate("/kyc-kyb/identity-verification/business-info");
        // }
      } catch (error) {
        console.log(error);
      }
    },
  });

  const handleErrorData = () => {
    if (!loginInvestorId || isBusinessRegUpdate) return;

    let errorData: any = {};
    let errorDataBusiness: any = {};
    let touchedData: any = {};
    let touchedDataBusiness: any = {};

    const requiredDocs = loginUserDetails?.DocumentRequiredFor || "";

    if (requiredDocs === "session_identifier") {
      navigate("/kyc-kyb/identity-verification/failed");
      return;
    } else if (requiredDocs === "velocity") {
      navigate("/kyc-kyb/identity-verification/pending");
      return;
    }
    let reasonObj: any = {};
    try {
      reasonObj = typeof loginUserDetails.Responses === "string"
        ? JSON.parse(loginUserDetails.Responses)
        : loginUserDetails.Responses || {};
    } catch (err) {
      console.error("Invalid JSON in profile.Responses");
    }
    // Mapping external field names to Formik field keys
    const fieldMappingBusiness: Record<string, string> = {
      email: "Email",
      ein: "IdNumber",
      business: "BusinessName",
      address: "DeliveryLine",
    };
    const fieldMappingIndividual: Record<string, string> = {
      email: "email",
      phone: "phone",
      ssn: "socialSecurityNumber",
      address: "address",
      zip: "ZipCode",
      city: "city",
      state: "state",
      birthdate: "dateOfBirth",
      full_name: "lastName",
    };
    const message = reasonObj?.message || "";
    // Parse the "field:message" style
    if (typeof message === "string" && message.includes(":")) {
      const [field, msg] = message.split(":");
      const fieldKey = field.trim().toLowerCase();
      const errorMsg = msg.trim();

      if (loginUserDetails.UserType === "business") {
        const formikKey = fieldMappingBusiness[fieldKey];
        if (formikKey) {
          errorDataBusiness[formikKey] = errorMsg;
          touchedDataBusiness[formikKey] = true;
        }
      } else {
        const formikKey = fieldMappingIndividual[fieldKey];
        if (formikKey) {
          errorData[formikKey] = errorMsg;
          touchedData[formikKey] = true;
        }
      }
    }
    // If there are DocumentRequiredFor errors
    if (requiredDocs !== "") {
      if (loginUserDetails.UserType === "business") {

        errorDataBusiness = {
          ...errorDataBusiness,
          IdNumber: requiredDocs.includes("ein") ? "EIN did not match" : requiredDocs.includes("business") || requiredDocs.includes("address") ? true : "",
          BusinessName: requiredDocs.includes("business") ? "Business Name did not match" : "",
          DeliveryLine: requiredDocs.includes("address") ? "Address did not match" : "",
        };

        // Clean out empty values
        touchedDataBusiness = {
          ...touchedDataBusiness,
          IdNumber: !requiredDocs.includes("ein") || !requiredDocs.includes("business") || !requiredDocs.includes("address") || businessFormik.values.IdNumber === "",
          BusinessName: !requiredDocs.includes("business") || businessFormik.values.BusinessName === "",
          DeliveryLine: !requiredDocs.includes("address") || businessFormik.values.DeliveryLine === "",
        };
      } else {
        errorData = {
          ...errorData,
          lastName: requiredDocs.includes("full_name") ? "OFAC sanctions match" : requiredDocs.includes("birthdate") ? true : "",
          email: requiredDocs.includes("email") && "Email risk",
          phone: requiredDocs.includes("phone") && "Phone risk",
          socialSecurityNumber: requiredDocs.includes("ssn") ? "SSN did not match" : individualFormik.values.socialSecurityNumber === "" ? "Social Security Number is required" : "",
          address: requiredDocs.includes("address") && "Address did not match",
          ZipCode: requiredDocs.includes("address") ? true : "",
          city: requiredDocs.includes("address") ? true : "",
          state: requiredDocs.includes("address") ? true : "",
          dateOfBirth: requiredDocs.includes("birthdate") ? "Birthdate did not match" : individualFormik.values.dateOfBirth === null ? "Date of birth is required" : "",
        };

        touchedData = {
          ...touchedData,
          lastName: requiredDocs.includes("full_name") || requiredDocs.includes("birthdate"),
          email: requiredDocs.includes("email"),
          phone: requiredDocs.includes("phone"),
          socialSecurityNumber: requiredDocs.includes("ssn") || individualFormik.values.socialSecurityNumber === "",
          address: requiredDocs.includes("address"),
          dateOfBirth: requiredDocs.includes("birthdate") || individualFormik.values.dateOfBirth === null,
          ZipCode: requiredDocs.includes("address"),
          city: requiredDocs.includes("address"),
          state: requiredDocs.includes("address"),
        };
      }
    } else {
      // Fallback if no DocumentRequiredFor data
      touchedDataBusiness = {
        ...touchedDataBusiness,
        ...businessFormik.touched,
        IdNumber: true,
      };
      errorDataBusiness = {
        ...errorDataBusiness,
        IdNumber: "EIN number is required.",
      };
      touchedData = {
        ...individualFormik.touched,
        socialSecurityNumber: individualFormik.values.socialSecurityNumber === "",
      };
    }

    setErrors(errorDataBusiness)
    setKycError(errorData)
    // Apply to formik
    individualFormik.setErrors(errorData);
    businessFormik.setErrors(errorDataBusiness);
    individualFormik.setTouched(touchedData);
    businessFormik.setTouched(touchedDataBusiness);


  };

  const handleFailure = async () => {
    setDialogOpen(false);
    setChecking(false);
    setDialogOpenUpdate(false);
    handleErrorData();
  };
  useEffect(() => {
    handleErrorData();
  }, [loginUserDetails, loginInvestorId]);

  useEffect(() => {
    if (loginUserDetails?.IsSilaRegistered === false) {
      handleFailure();
    }
    else if (kycDetails?.body[0]?.verification_status === "failed") {
      navigate("/kyc-kyb/identity-verification/failed");
    }
    if (kycDetails?.body[0]?.verification_status === "pending") {
      setAttemptCount(attemptCount + 1);
    } else if (
      kycDetails?.statusCode === 200 &&
      kycDetails?.body[0]?.verification_status === "passed"
    ) {
      handleCallFechtapi();
      dispatch(initialResetState());
      navigate("/kyc-kyb/bidding-agreement");
    } else if (
      (kycDetails?.body[0]?.kyc_action === "entity_data" ||
        kycDetails?.body[0]?.kyc_action === null) &&
      kycDetails?.body[0]?.verification_status === "documents_required"
    ) {
      handleFailure();
      handleCallFechtapi();
    } else if (
      kycDetails?.body[0]?.kyc_action === "doc_upload" &&
      kycDetails?.body[0]?.verification_status === "documents_required"
    ) {
      handleCallFechtapi();
      setTimeout(() => {
        navigate(
          "/kyc-kyb/identity-verification/individual/additional-document"
        );
      }, 500);
    }
  }, [kycDetails]);

  useEffect(() => {
    let intervalId: any;
    let timeoutId: any;
    // Call the KYC details API when investorId is present and dialog is open
    if ((dialogOpen && loginInvestorId) || checking) {
      intervalId = setInterval(() => {
        handleKycDetails();
        setAttemptCount((prev) => prev + 1); // Increment attempt count
        setTimeOutInterval(15000);
        if (attemptCount > 2) {
          // 5 attempts (0 to 4)
          clearInterval(intervalId);
          navigate(
            "/kyc-kyb/identity-verification/individual/inprogress-validate"
          );
        }
      }, timeOutInterval); // 10 seconds interval

      // Set a timeout to clear the interval and navigate after 60 seconds
      timeoutId = setTimeout(() => {
        clearInterval(intervalId);
        setKycdetails(null);
        navigate(
          "/kyc-kyb/identity-verification/individual/inprogress-validate"
        );
      }, 120000); // 60 seconds timeout
    }
    // Cleanup function to clear interval and timeout when dialog closes or component unmounts
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [dialogOpen, loginInvestorId, checking, attemptCount]); // Add attemptCount as a dependency

  const normalizeUserData = (data: IndividualFormValues) => ({
    investorId: loginInvestorId || 0,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    phone: formatPhoneNumber(data.phone),
    userName: `${capitalize(data.firstName)} ${capitalize(data.lastName)}`,
    birthDate: moment(data.dateOfBirth.$d).format("YYYY-MM-DD"),
    deliveryLine: data.address,
    deliveryLine2: data.addressLine2,
    city: capitalize(data.city),
    state: data.state || userData?.state,
    country: "US",
    zipCode: formatZipCode(data.ZipCode),
    idNumber: data.socialSecurityNumber.replace(/\D/g, ""),
    userType: selectedValue,
    documentId: data.documentId,
    documentType: data.documentType,
    documentState: data.documentState,
    documentCountry: data.documentCountry,
    SignupEmail: msalInstance.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || userData?.email || '',
  });

  // Individual formik instance

  const normalizeBusinessData = (data: BusinessFormValues) => ({
    investorId: loginInvestorId || 0,
    BusinessName: data.BusinessName || "",
    BusinessTypeId: data.BusinessTypeId || 0,
    BusinessCategoriesId: data.BusinessCategoriesId || 0,
    subCategory: data.subCategory,
    Email: data.Email || "",
    Phone: formatPhoneNumber(data.Phone),
    DeliveryLine: data.DeliveryLine || "",
    City: capitalize(data.City) || "",
    State: data.State || "",
    Country: data.Country || "US",
    ZipCode: formatZipCode(data.ZipCode),
    IdNumber: data?.IdNumber?.replace(/\D/g, ""),
    BusinessWebsite: data.BusinessWebsite || "",
    UserType: "business",
    OperatingAs: data.OperatingAs || "",
    RegistrationDate: data.RegistrationDate ? moment(data.RegistrationDate.$d).format("YYYY-MM-DD") : "",
    RegistrationState: data.RegistrationState || "",
    SignupEmail: msalInstance.getActiveAccount()?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || userData?.email,
  });

  useEffect(() => {
    if (loginUserDetails.UserType) {
      setSelectedValue(loginUserDetails.UserType);
      if (loginUserDetails.UserType === "individual")
        individualFormik.setValues({
          ...individualFormik.values,
          firstName: loginUserDetails.FirstName,
          lastName: loginUserDetails.LastName,
          email: loginUserDetails?.Email,
          phone: loginUserDetails?.Phone,
          socialSecurityNumber: "",
          dateOfBirth: null,
          address: loginUserDetails.DeliveryLine,
          addressLine2: loginUserDetails.DeliveryLine2,
          city: loginUserDetails.City,
          state: loginUserDetails.State,
          ZipCode: loginUserDetails.ZipCode,
          Country: loginUserDetails?.Country,
        });
      else {
        // Find the category based on the user's category name
        let subCategory: any; // Default to 0 if no subcategory found
        let category: any;
        const categoryId =
          businesscategory &&
          businesscategory?.filter(
            (typeId: any) =>
              typeId.categoryName ===
              loginUserDetails.BusinessDetailsResponse.Category
          );
        // Check if categoryId is valid (not empty) before proceeding
        if (categoryId?.length > 0) {
          category = categoryId[0];
          // Attempt to find the subcategory based on the user's subcategory name
          if (category && category?.children) {
            const foundSubCategory = category?.children?.filter(
              (typeId: any) =>
                typeId?.id ===
                loginUserDetails.BusinessDetailsResponse.BusinessCategoryId
            );

            // If a subcategory is found, use its ID
            if (foundSubCategory && foundSubCategory?.length > 0) {
              subCategory = {
                value: foundSubCategory[0]?.id,
                label: foundSubCategory[0]?.categoryName,
              };
            }
          }
        }
        businessFormik.setValues({
          ...businessFormik.values,
          Email: bussinessUserdata?.Email || loginUserDetails?.Email || "", // Use loginUserDetails Email
          Phone: bussinessUserdata?.Phone || loginUserDetails?.Phone || "", // Use loginUserDetails Phone
          DeliveryLine: loginUserDetails?.DeliveryLine || "",
          DeliveryLine2: loginUserDetails?.DeliveryLine2 || "",
          City: loginUserDetails?.City || "",
          State: loginUserDetails?.State || "",
          Country: loginUserDetails?.Country || "US", // Default country to US if not available
          ZipCode: loginUserDetails.ZipCode || "",
          BusinessName: loginUserDetails.BusinessDetailsResponse.BusinessName,
          UserType: "business", // Static user type as 'business'
          OperatingAs: loginUserDetails?.BusinessDetailsResponse?.OperatingAs,
          BusinessTypeId:
            loginUserDetails.BusinessDetailsResponse?.BusinessTypeId, // Default business type ID
          BusinessCategoriesId: category?.id, // Default business category ID
          BusinessWebsite:
            loginUserDetails.BusinessDetailsResponse?.BusinessWebsite || "", // Default empty business website
          subCategory: subCategory?.value || "", // Dynamically set subcategory
          RegistrationDate: loginUserDetails.BusinessDetailsResponse?.RegistrationDate,
          RegistrationState: loginUserDetails.BusinessDetailsResponse?.RegistrationState,
        });
      }
    }
  }, [businesscategory]);


  useEffect(() => {
    if (bussinessUserdata?.UserType === "business") {
      // Update form values with bussinessUserdata if it exists
      businessFormik.setValues({
        ...bussinessUserdata,
        Email: bussinessUserdata?.Email || activeAccount?.idTokenClaims?.email || sessionStorage.getItem('impersonateEmail') || "", // Default empty email if not provided
        Phone: bussinessUserdata?.Phone || activeAccount?.idTokenClaims?.extension_phoneNumber || "", // Default empty phone if not provided
        DeliveryLine: bussinessUserdata?.DeliveryLine ?? "", // Default empty delivery line if not provided
        City: bussinessUserdata?.City ?? "", // Default empty city if not provided
        State: bussinessUserdata?.State ?? "", // Default empty state if not provided
        Country: bussinessUserdata?.Country ?? "US", // Default to "US" if not provided
        ZipCode: bussinessUserdata?.ZipCode ?? "", // Default empty zip code if not provided
        IdNumber: bussinessUserdata?.IdNumber ?? "", // Default empty business ID number if not provided
        BusinessName: bussinessUserdata?.BusinessName ?? "", // Default empty business name if not provided
        BusinessTypeId: bussinessUserdata?.BusinessTypeId ?? 0, // Default 0 if not provided
        BusinessCategoriesId: bussinessUserdata?.BusinessCategoriesId ?? 0, // Default 0 if not provided
        OperatingAs: bussinessUserdata?.OperatingAs ?? "", // Default empty operating as field if not provided
        BusinessWebsite: bussinessUserdata?.BusinessWebsite ?? "", // Default empty business website if not provided
        UserType: "business", // Static user type as 'business',
        RegistrationDate: bussinessUserdata?.RegistrationDate ?? "",
        RegistrationState: bussinessUserdata?.RegistrationState ?? ""
      });

      setSelectedValue("business");
    }
  }, []);

  useEffect(() => {
    if (!bussinessUserdata?.UserType && !loginInvestorId && selectedValue === 'business') {
      businessFormik.setFieldValue(
        "Email",
        activeAccount?.idTokenClaims?.email || userData?.email || sessionStorage.getItem('impersonateEmail') || ""
      );
      businessFormik.setFieldValue(
        "Phone",
        activeAccount?.idTokenClaims?.extension_phoneNumber ||
        userData?.phone ||
        ""
      );
    }
  }, [selectedValue])

  useEffect(() => {
    if (activeAccount && activeAccount?.idTokenClaims) {
      individualFormik.setFieldValue(
        "firstName",
        loginUserDetails.FirstName ||
        activeAccount?.idTokenClaims?.given_name ||
        ""
      );
      individualFormik.setFieldValue(
        "lastName",
        loginUserDetails.LastName ||
        activeAccount?.idTokenClaims?.family_name ||
        ""
      );
      individualFormik.setFieldValue(
        "email",
        activeAccount?.idTokenClaims?.email || userData?.email || sessionStorage.getItem('impersonateEmail') || ""
      );
      individualFormik.setFieldValue(
        "phone",
        activeAccount?.idTokenClaims?.extension_phoneNumber ||
        userData?.phone ||
        ""
      );

    }
  }, [instance]);

  const handleFieldChange = (e: any, tempData: any, id: any) => {
    const { name, value } = e.target;
    const maxLengths: any = {
      address: 40,
      city: 40,
      addressLine2: 40,
      socialSecurityNumber: 9,
      ZipCode: 10,
      phone: 10,
    };

    let trimmedValue = value;
    const inputElement = e.target;
    const cursorPosition = inputElement.selectionStart;

    // Helper function to restore cursor position
    const restoreCursorPosition = (newPosition: number) => {
      requestAnimationFrame(() => {
        if (inputElement && inputElement === document.activeElement) {
          inputElement.setSelectionRange(newPosition, newPosition);
        }
      });
    };

    // Handle phone number field
    if (name === "phone" || name === "Phone") {
      const originalValue = value;
      const digitsOnly = value.replace(/\D/g, "");

      if (digitsOnly.length > maxLengths.phone) {
        return; // Freeze value
      }

      // Calculate new cursor position based on digits before cursor
      const digitsBeforeCursor = originalValue.slice(0, cursorPosition).replace(/\D/g, "").length;

      // Calculate formatting characters before the cursor position
      const formattingBeforeCursor = originalValue.slice(0, cursorPosition).replace(/[0-9]/g, '').length;

      // The new cursor position should be: digits position + formatting characters
      let newCursorPosition = digitsBeforeCursor + formattingBeforeCursor;

      // Apply phone formatting
      trimmedValue = value.replace(/[A-Za-z]/g, "").replace(/[\s(),-]/g, "");

      // Format the phone number with proper formatting
      let formattedValue = trimmedValue;
      if (trimmedValue.length >= 3) {
        formattedValue = `(${trimmedValue.slice(0, 3)})`;
        if (trimmedValue.length >= 6) {
          formattedValue += ` ${trimmedValue.slice(3, 6)}`;
          if (trimmedValue.length >= 10) {
            formattedValue += `-${trimmedValue.slice(6, 10)}`;
          } else {
            formattedValue += trimmedValue.slice(6);
          }
        } else {
          formattedValue += ` ${trimmedValue.slice(3)}`;
        }
      }

      individualFormik.setFieldValue(name, formattedValue);
      individualFormik.setFieldTouched(name, true);

      // Adjust cursor position for the formatted value
      setTimeout(() => {
        if (inputElement && inputElement === document.activeElement) {
          // Calculate the actual cursor position in the formatted string
          let actualPosition = digitsBeforeCursor;

          // Add formatting characters based on digit count
          if (digitsBeforeCursor > 0) actualPosition += 1; // Opening parenthesis
          if (digitsBeforeCursor > 3) actualPosition += 2; // Closing parenthesis + space
          if (digitsBeforeCursor > 6) actualPosition += 1; // Hyphen

          inputElement.setSelectionRange(actualPosition, actualPosition);
        }
      }, 0);

      setKycError((prev: any) => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return;
    }
    // ZipCode logic
    else if (name === "ZipCode") {
      const originalValue = value;
      const digitsOnly = value.replace(/\D/g, "");

      if (digitsOnly.length > 9) { // Max 9 digits for ZIP
        return; // Freeze value
      }

      // Calculate new cursor position
      const digitsBeforeCursor = originalValue.slice(0, cursorPosition).replace(/\D/g, "").length;
      let newCursorPosition = digitsBeforeCursor;

      // Adjust for hyphens in formatted ZIP
      if (digitsBeforeCursor > 5) {
        newCursorPosition += 1; // Account for hyphen
      }

      trimmedValue = value?.replace(/[^\d-]/g, "");
      const parts = trimmedValue.split("-");
      if (parts.length > 1) {
        trimmedValue = `${parts[0]}-${parts.slice(1).join("")}`;
      }

      const numbers = trimmedValue?.replace(/\D/g, "");
      if (numbers.length <= 5) {
        trimmedValue = numbers;
      } else if (numbers.length > 5) {
        const firstPart = numbers.slice(0, 5);
        const secondPart = numbers.slice(5, 9);
        trimmedValue = secondPart ? `${firstPart}-${secondPart}` : firstPart;
      }

      const isValid = /^\d{5}(-\d{4})?$/.test(trimmedValue);
      if (!isValid && trimmedValue.length !== 5) {
        const errorMsg = "ZIP code must be in format 00000 or 00000-0000";
        individualFormik.setErrors({
          ...individualFormik.errors,
          [name]: errorMsg,
        });
        setKycError((prev: any) => ({
          ...prev,
          [name]: errorMsg,
        }));
      } else {
        const newErrors: any = { ...individualFormik.errors };
        delete newErrors[name];
        individualFormik.setErrors(newErrors);
        setKycError((prev: any) => {
          const { [name]: _, ...rest } = prev;
          return rest;
        });
      }

      individualFormik.setFieldValue(name, trimmedValue);
      individualFormik.setFieldTouched(name, true);
      restoreCursorPosition(newCursorPosition);
      return;
    }
    // Social Security Number logic
    else if (name === "socialSecurityNumber") {
      const originalValue = value;
      const digitsOnly = value.replace(/\D/g, "");

      if (digitsOnly.length > maxLengths.socialSecurityNumber) {
        return; // Freeze value
      }

      // Calculate new cursor position
      const digitsBeforeCursor = originalValue.slice(0, cursorPosition).replace(/\D/g, "").length;
      let newCursorPosition = digitsBeforeCursor;

      // Adjust for hyphens in formatted SSN
      if (digitsBeforeCursor > 3) {
        newCursorPosition += 1; // First hyphen
      }
      if (digitsBeforeCursor > 5) {
        newCursorPosition += 1; // Second hyphen
      }

      // Format SSN
      let formattedValue = digitsOnly;
      if (digitsOnly.length > 3) {
        formattedValue = digitsOnly.slice(0, 3) + "-" + digitsOnly.slice(3);
      }
      if (digitsOnly.length > 5) {
        formattedValue = formattedValue.slice(0, 6) + "-" + digitsOnly.slice(5);
      }

      individualFormik.setFieldValue(name, formattedValue);
      individualFormik.setFieldTouched(name, true);
      restoreCursorPosition(newCursorPosition);

    } else if (name === "city") {
      trimmedValue = value.replace(/[^a-zA-Z\s'-]/g, "")
      // Clear any previous error
      setKycError((prev: any) => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
    }
    // General max length logic
    else if (maxLengths[name]) {
      if (value.length > maxLengths[name]) {
        setKycError((prev: any) => ({
          ...prev,
          [name]: `Maximum length is ${maxLengths[name]} characters`,
        }));
        return; // Freeze value, do not update Formik
      } else {
        setKycError((prev: any) => {
          const { [name]: _, ...rest } = prev;
          return rest;
        });
      }
      trimmedValue = value.slice(0, maxLengths[name]);
    } else if (name === "documentType") {
      individualFormik.setFieldValue("documentCountry", "");
      individualFormik.setFieldValue("documentState", "");
    }
    else {
      // Clear any previous error
      setKycError((prev: any) => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
    }

    // Set the field value
    if (name === "state") {
      individualFormik.setFieldValue("state", tempData.value);
    } else {
      individualFormik.setFieldValue(name, trimmedValue);
    }

    // Mark field as touched - use the appropriate formik instance
    if (selectedValue === "individual") {
      individualFormik.setFieldTouched(name, true);
    } else {
      businessFormik.setFieldTouched(name, true);
    }

    // === ✅ Update kycError dynamically based on conditions ===
    const updatedKycErrors: any = { ...kycError };
    const requiredDocs = loginUserDetails?.DocumentRequiredFor || "";

    switch (name) {
      case "lastName":
        if (requiredDocs.includes("full_name")) {
          updatedKycErrors[name] = "OFAC sanctions match";
        } else if (requiredDocs.includes("birthdate")) {
          updatedKycErrors[name] = true;
        } else {
          delete updatedKycErrors[name];
        }
        break;

      case "email":
        if (requiredDocs.includes("email")) {
          updatedKycErrors[name] = "Email risk";
        } else {
          delete updatedKycErrors[name];
        }
        break;

      case "phone":
        if (requiredDocs.includes("phone")) {
          updatedKycErrors[name] = "Phone risk";
        } else {
          delete updatedKycErrors[name];
        }
        break;

      case "socialSecurityNumber":
        if (requiredDocs.includes("ssn")) {
          updatedKycErrors[name] = "SSN not matched";
        } else if (!trimmedValue) {
          updatedKycErrors[name] = "Social Security Number is required";
        } else {
          delete updatedKycErrors[name];
        }
        break;

      case "address":
        if (requiredDocs.includes("address")) {
          updatedKycErrors[name] = "Address not matched";
        } else {
          delete updatedKycErrors[name];
        }
        break;

      case "ZipCode":
      case "city":
      case "state":
        if (requiredDocs.includes("address")) {
          updatedKycErrors[name] = true;
        } else {
          delete updatedKycErrors[name];
        }
        break;

      case "dateOfBirth":
        if (requiredDocs.includes("birthdate")) {
          updatedKycErrors[name] = "Birthdate not matched";
        } else if (!individualFormik.values.dateOfBirth) {
          updatedKycErrors[name] = "Date of birth is required";
        } else {
          delete updatedKycErrors[name];
        }
        break;

      default:
        delete updatedKycErrors[name];
    }
    setKycError(updatedKycErrors);
  };

  // Individual form paste handler
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const { name } = e.target as HTMLInputElement;
    let pastedValue = e.clipboardData.getData('Text');
    if (name === "phone" || name === "Phone") {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 10);
      let formatted = pastedValue;
      if (pastedValue.length >= 3) {
        formatted = `(${pastedValue.slice(0, 3)})`;
        if (pastedValue.length >= 6) {
          formatted += ` ${pastedValue.slice(3, 6)}`;
          if (pastedValue.length >= 10) {
            formatted += `-${pastedValue.slice(6, 10)}`;
          } else {
            formatted += pastedValue.slice(6);
          }
        } else {
          formatted += ` ${pastedValue.slice(3)}`;
        }
      }
      individualFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === "ZipCode") {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 9);
      let formatted = pastedValue;
      if (pastedValue.length > 5) {
        formatted = `${pastedValue.slice(0, 5)}-${pastedValue.slice(5, 9)}`;
      }
      individualFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === "socialSecurityNumber") {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 9);
      let formatted = pastedValue;
      if (pastedValue.length > 3) {
        formatted = `${pastedValue.slice(0, 3)}-${pastedValue.slice(3)}`;
      }
      individualFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    }
    // Default: just set the value
    individualFormik.setFieldValue(name, pastedValue);
    e.preventDefault();
  };

  // Business form paste handler
  const handleBusinessPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const { name } = e.target as HTMLInputElement;
    let pastedValue = e.clipboardData.getData('Text');
    if (name === 'Phone' || name === 'phone') {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 10);
      let formatted = pastedValue;
      if (pastedValue.length >= 3) {
        formatted = `(${pastedValue.slice(0, 3)})`;
        if (pastedValue.length >= 6) {
          formatted += ` ${pastedValue.slice(3, 6)}`;
          if (pastedValue.length >= 10) {
            formatted += `-${pastedValue.slice(6, 10)}`;
          } else {
            formatted += pastedValue.slice(6);
          }
        } else {
          formatted += ` ${pastedValue.slice(3)}`;
        }
      }
      businessFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === 'ZipCode') {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 9);
      let formatted = pastedValue;
      if (pastedValue.length > 5) {
        formatted = `${pastedValue.slice(0, 5)}-${pastedValue.slice(5, 9)}`;
      }
      businessFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === 'IdNumber') {
      pastedValue = pastedValue.replace(/\D/g, '').slice(0, 9);
      let formatted = pastedValue;
      if (pastedValue.length > 2) {
        formatted = `${pastedValue.slice(0, 2)}-${pastedValue.slice(2)}`;
      }
      businessFormik.setFieldValue(name, formatted);
      e.preventDefault();
      return;
    } else if (name === 'City') {
      pastedValue = pastedValue.replace(/[^a-zA-Z\s'-]/g, '').slice(0, 40);
      businessFormik.setFieldValue(name, pastedValue);
      e.preventDefault();
      return;
    } else if (name === 'DeliveryLine' || name === 'BusinessName' || name === 'OperatingAs' || name === 'BusinessWebsite') {
      pastedValue = pastedValue.slice(0, 40);
      businessFormik.setFieldValue(name, pastedValue);
      e.preventDefault();
      return;
    }
    // Default: just set the value
    businessFormik.setFieldValue(name, pastedValue);
    e.preventDefault();
  };


  useEffect(() => {
    if (states?.length < 1) {
      dispatch(fetchStates()).unwrap();
    }
  }, [dispatch]);

  useEffect(() => {
    selectedValue === "individual"
      ? individualFormik.validateForm()
      : businessFormik.validateForm();
  }, [individualFormik.values, businessFormik.values]);

  const validateBeforeSubmit = async () => {
    const form =
      selectedValue === "individual" ? individualFormik : businessFormik;

    form.setTouched(
      Object.keys(form.values).reduce((acc, field) => {
        acc[field] = true;
        return acc;
      }, {} as any)
    );

    const errors = await form.validateForm();
    if (Object.keys(errors).length) {
      selectedValue === "individual"
        ? individualFormik.setErrors(errors)
        : businessFormik.setErrors(errors);
    } else {
      selectedValue === "individual"
        ? individualFormik.handleSubmit()
        : businessFormik.handleSubmit();
    }
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (loginInvestorId) {
    } else {
      if (event.target.value === "individual") {
        dispatch(businessUserEmpty());
      }
      setSelectedValue(event.target.value);
    }
  };

  const handleDateChange = (date: any, fieldName?: string) => {

    if (fieldName === "RegistrationDate") {
      individualFormik.setFieldValue(
        "RegistrationDate",
        date ? dayjs(moment(date.$d).format("YYYY-MM-DD")) : null
      );

    } else {
      individualFormik.setTouched({
        ...individualFormik.touched,
        ["dateOfBirth"]: true
      })
      individualFormik.setFieldValue(
        "dateOfBirth",
        date ? dayjs(moment(date.$d).format("YYYY-MM-DD")) : null
      );
    }
  };

  const handleErrorModel = () => {
    individualFormik.setValues({
      ...individualFormik.values,
      socialSecurityNumber: "",
      dateOfBirth: null,
      documentId: ""
    })
    setOpenErrorModel(false)
    individualFormik.setErrors({
      ...individualFormik.errors,
    })
  }
  return (
    <div
      className="flex flex-col items-center pb-6 mt-4"
      data-testid="identity-verification-form"
    >
      <Dialog
        open={openErrorModel}
        PaperProps={{
          component: "form",
          style: {
            width: "80%", // Set custom width
            maxWidth: "550px", // Optional: set max width
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Poppins",
            fontWeight: 400,
          }}
        >

          <Box
            fontSize={"14px"}
            sx={{ color: textColor.fontColor }}
            fontWeight={400}
            textAlign={"left"}
            my={1}
          >
            There was an issue registering one or more entities. Please review and correct the highlighted fields in the form before resubmitting.
          </Box>
          <Box
            fontSize={"14px"}
            sx={{ color: textColor.fontColor }}
            fontWeight={400}
            textAlign={"left"}
            mb={2}
          >
            <span className="font-semibold">Note</span>: We do not store personally identifiable information (PII), so you may be required to re-enter fields such as EIN, SSN, and Date of Birth.
          </Box>
          <ButtonComponents

            label="OK"
            onClick={handleErrorModel}
            sx={{
              backgroundColor: "#FF5C39",
              color: "#fff",
              mt: 2,
              "&:hover": { backgroundColor: "#e65232" },
              my: "auto"
            }}
            data-testid="OK-button"
          />

        </DialogContent>
      </Dialog>
      <Dialog
        open={dialogOpenUpdate ? true : dialogOpen}
        // maxWidth={"xs"}
        PaperProps={{
          component: "form",
          style: {
            width: "80%", // Set custom width
            maxWidth: "550px", // Optional: set max width
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            fontSize: 18,
            fontFamily: "Poppins",
            fontWeight: 400,
          }}
        >
          <Box display={"flex"} justifyContent={"center"} my={2}>
            <div className="loader"></div>
          </Box>
          <Box fontSize={"14px"}>
            {`${selectedValue === "individual" ? "Identity" : "Business"
              } verification is in progress and may take a few minutes.
              `}
            <br />
            Please do not refresh your browser or hit the back button.
          </Box>
        </DialogContent>
      </Dialog>
      <div
        className="max-w-[100%] md:max-w-[45%] w-full h-full overflow-hidden bg-white p-4 md:p-7 rounded-lg md:shadow-md"
        data-testid="form-container"
      >
        <Typography
          fontSize={{ md: 24, sm: 20 }}
          pb={2}
          color={"#3B3B3B"}
          align="center"
          fontWeight={{ md: 600, sm: 400 }}
          data-testid="form-title"
        >
          Identity Verification
        </Typography>
        <Typography
          sx={{
            color: "#3B3B3B",
            fontSize: { md: 16, sm: 14 },
            fontWeight: { md: 500, sm: 400 },
          }}
          data-testid="form-subtitle"
        >
          Are you registering as an individual or a business?
        </Typography>
        <RadioGroupComponents
          selectedValue={selectedValue}
          handleRadioChange={handleRadioChange}
          options={[
            { label: "Individual", value: "individual" },
            { label: "Business", value: "business" },
          ]}
          disabled={loginInvestorId ? true : false}
          color="#FF5C39"
          direction="row"
          data-testid="user-type-radio-group"
        />
        <form data-testid="identity-verification-form-content">
          <Box>
            {selectedValue === "individual" ? (
              <IndividualForm
                values={individualFormik.values}
                errors={{ ...individualFormik.errors, ...kycError }}
                touched={individualFormik.touched}
                handleChange={handleFieldChange}
                handleDateChange={handleDateChange}
                handlePaste={handlePaste}
                // handleKeyDown={handleKeyDown}
                data-testid="individual-form"
              />
            ) : (
              <BusinessForm
                isDisabled={false}
                formik={businessFormik}
                values={businessFormik.values}
                errors={{ ...businessFormik.errors, ...errors }}
                touched={businessFormik.touched}
                data-testid="business-form"
                size={"small"}
                setErrors={setErrors}
                handlePaste={handleBusinessPaste}
              />
            )}
          </Box>
          <div
            className="flex justify-center mt-6"
            data-testid="submit-button-container"
          >
            <ButtonComponents
              onClick={validateBeforeSubmit}
              label={selectedValue === "individual" ? "Submit" : "Next"}
              variant="contained"
              sx={{
                fontSize: 14,
                borderRadius: "9px",
                backgroundColor:
                  (selectedValue === "individual"
                    ? !individualFormik.isValid || !individualFormik.dirty
                    : !businessFormik.isValid || !businessFormik.dirty)
                    ? "#9fa4ab"
                    : "#FF5C39",
                color: "#fff",
                border: (selectedValue === "individual"
                  ? !individualFormik.isValid || !individualFormik.dirty
                  : !businessFormik.isValid || !businessFormik.dirty)
                  ? "1px solid transparent"
                  : undefined,
                '&:hover': {
                  backgroundColor:
                    (selectedValue === "individual"
                      ? !individualFormik.isValid || !individualFormik.dirty
                      : !businessFormik.isValid || !businessFormik.dirty)
                      ? "#9fa4ab"
                      : "#e65232",
                  border: (selectedValue === "individual"
                    ? !individualFormik.isValid || !individualFormik.dirty
                    : !businessFormik.isValid || !businessFormik.dirty)
                    ? "1px solid transparent"
                    : undefined,
                  boxShadow: (selectedValue === "individual"
                    ? !individualFormik.isValid || !individualFormik.dirty
                    : !businessFormik.isValid || !businessFormik.dirty)
                    ? "none" : undefined,

                },
              }}
              datatestid="submit-button"
            />
          </div>
        </form>
      </div>
      {/* } */}
      <ToastContainer />
    </div>
  );
};

export default IdentityVerificationForm;
